import { httpClient } from "./httpClient";

const getAllDemand = () => {
  return httpClient.get("showDemand");
};

export default {
  getAllDemand,
};
